import zbWithdrawal from './zb-withdrawal.vue'

export default zbWithdrawal
